<template>
  <v-app id="admin-login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-form @submit.prevent="onSubmtiLogin" ref="loginForm">
                <v-toolbar dark color="primary">
                  <v-toolbar-title  class="white--text">BacBon School | Login</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-text-field name="login" label="Username" v-model="user.username"  :rules="nameRules" type="text"></v-text-field>
                    <v-text-field id="password" name="password" v-model="user.password" :rules="passwordRules" label="Password" type="password"></v-text-field>
                </v-card-text>
                <v-card-actions>
                  
                  <v-btn type="button" @click="goLMS" color="blue">LMS</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn type="submit" color="green">Login</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar
      :color="color"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      v-model="snackbar"
      dark
    >
      <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
      <div>{{ noticeMessage }}</div>
      <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
    </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
  export default {
    data: () => ({
      color: null,
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      drawer: null,
      noticeMessage: '',
      nameRules: [
        v => !!v || 'Username is required'
      ],
      passwordRules: [
        v => !!v || 'Password is required'
      ],
    }),
    props: {
      source: String
    },
  computed: {
    ...mapState("login", ["user"]),
  },
  methods: {
    ...mapActions("login", ["doLogin"]),
    onSubmtiLogin (event) {
      if (this.$refs.loginForm.validate()) {
        this.doLogin().then(response => {
          if (response.status === 'OK') {
            this.color = "success";
            this.noticeMessage = response.message;
            this.snack("top");
            let d = new Date()
            d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000))
            let expires = 'expires=' + d.toUTCString()
            document.cookie = 'Token=' + response.token + ';' + expires + ';path=/'
            document.cookie = 'Info=' + JSON.stringify(response.data) + ';' + expires + ';path=/'
            this.$router.push('/dashboard')
          } else {
            console.log(response.message)
            this.color = "warning";
            this.noticeMessage = response.message;
            this.snack("top");
          }
        })
      } else {
        console.log('Invalid')
      }
    },
    goLMS () {
      this.$router.push('lms')
    },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }
      this.snackbar = true;
    }
  }
  }
</script>